export type Side =
  "din-barnehageside"
  | "pris-søknader"
  | "avslutt-pris-søknader"
  | "dine-saker"
  | "pris-søknad"
  | "oppsigelse"
  | "oppsigelse-status"
  | "oppsigelse-kvittering"
  | "permisjon"
  | "permisjon-kvittering"
  | "permisjon-status"

const osloKommunePostfix = '- Oslo kommune'

export const getDefaultDocumentTitle = `Din barnehageside ${osloKommunePostfix}`

export const getDocumentTitle = (side: Side) => {
  switch (side) {
    case 'dine-saker':
      return `Dine saker ${osloKommunePostfix}`
    case 'pris-søknader':
      return `Status på søknader om redusert barnehagepris ${osloKommunePostfix}`
    case 'pris-søknad':
      return `Status søknad om redusert barnehagepris ${osloKommunePostfix}`
    case 'avslutt-pris-søknader':
      return `Stopp automatisk søknad om redusert barnehagepris ${osloKommunePostfix}`
    case 'oppsigelse':
      return `Oppsigelse av barnehageplass ${osloKommunePostfix}`
    case 'oppsigelse-status':
      return `Status på oppsigelse av barnehageplass ${osloKommunePostfix}`
    case 'oppsigelse-kvittering':
      return `Kvittering for oppsigelse av barnehageplass ${osloKommunePostfix}`
    case 'permisjon':
      return `Søknad om permisjon fra barnehagen ${osloKommunePostfix}`
    case 'permisjon-kvittering':
      return `Kvittering for søknad om permisjon fra barnehagen ${osloKommunePostfix}`
    case 'permisjon-status':
      return `Status på søknad om permisjon fra barnehagen ${osloKommunePostfix}`

    default:
      return getDefaultDocumentTitle
  }
}
